var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-8e4abb0a\",\"hasScoped\":false}!../../vue-loader/lib/selector?type=template&index=0!./bio-1.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-loader!./~/vue-markdown-loader/_cache/bio-1.vue
// module id = 165
// module chunks = 0